import { isMobile } from 'react-device-detect';
import DetectRTC from 'detectrtc';

export const mayUseChat = () => {
  return Promise.resolve(DetectRTC.isWebSocketsSupported && !DetectRTC.isWebSocketsBlocked);
};

export const mayUseAudioCall = () => {
  // Audio-Calls sind systemweit deaktiviert.
  // Diese Funktion bleibt als Abstraktionspunkt bestehen, liefert aber immer false,
  // um keine Berechtigungsabfragen (Mikrofon) mehr auszulösen.
  return Promise.resolve(false);
};

export const mayUseVideoCall = () => {
  // Video-Calls sind systemweit deaktiviert.
  // Diese Funktion bleibt als Abstraktionspunkt bestehen, liefert aber immer false,
  // um keine Berechtigungsabfragen (Kamera) mehr auszulösen.
  return Promise.resolve(false);
};

export const initAudioCall = (successCallback, errorCallback) => {
  if (DetectRTC.MediaDevices[0] && DetectRTC.MediaDevices[0].isCustomLabel) {
    navigator.mediaDevices
      .getUserMedia({
        audio: true,
      })
      .then(stream => {
        stream.getTracks().forEach(track => {
          track.stop();
        });

        successCallback();
      })
      .catch(errorCallback);
  } else {
    successCallback();
  }
};

export const initVideoCall = (successCallback, errorCallback) => {
  if (DetectRTC.MediaDevices[0] && DetectRTC.MediaDevices[0].isCustomLabel) {
    navigator.mediaDevices
      .getUserMedia({
        audio: true,
        video: true,
      })
      .then(stream => {
        stream.getTracks().forEach(track => {
          track.stop();
        });

        successCallback();
      })
      .catch(errorCallback);
  } else {
    successCallback();
  }
};

export const getUserMediaConstraintsArgumentsFromState = webrtccall => {
  const { type } = webrtccall;
  const options = {};

  if (isMobile) {
    options.facingMode = webrtccall.cameraFacingMode;
  } else {
  }

  return { type, options };
};

// available options:
//   - audioSource
//   - videoSource
//   - facingMode
export const getUserMediaConstraints = (type = 'video', options = {}) => {
  const audio = { deviceId: options.audioSource ? { exact: options.audioSource } : undefined };

  if (type === 'audio') {
    return { audio };
  }

  const video = { deviceId: options.videoSource ? { exact: options.videoSource } : undefined };

  if (isMobile) {
    video.facingMode = { exact: options.facingMode ? options.facingMode : 'user' };
    if (video.facingMode === 'user') {
      video.width = { ideal: 720 };
    } else {
      video.width = { ideal: 1280 };
    }

    return { audio, video };
  }

  video.width = { ideal: 1280 };
  video.height = { ideal: 720 };

  return { audio, video };
};
